module.exports = __webpack_public_path__ + "img/citizendetail.868d5ae9.png";